import { MessageCircleMore, User, Building2, FileStack } from 'lucide-react';
import { NavigateFunction } from 'react-router-dom';

export const HOME_CONFIGS = [
  {
    id: '1',
    icon: (
      <MessageCircleMore
        // size={64}
        className="w-full h-full group-hover:brightness-0 group-hover:invert transition duration-200 text-primary"
      />
    ),
    title: 'EAGLEGPT_TITLE',
    description: 'EAGLEGPT_DESCRIPTION',
    path: '/chat',
    isExternal: false,
    isPublic: true,
  },
  // {
  //   id: '2',
  //   icon: (
  //     <Signature
  //       // size={64}
  //       className="w-full h-full group-hover:brightness-0 group-hover:invert transition duration-200 text-primary"
  //     />
  //   ),
  //   title: 'ESIGNATURE_TITLE',
  //   description: 'ESIGNATURE_DESCRIPTION',
  //   path: 'https://selise.app/login?go=%2Fe-signature',
  //   isExternal: true,
  //   isPublic: false
  // },
  {
    id: '3',
    icon: (
      <User
        // size={64}
        className="w-full h-full group-hover:brightness-0 group-hover:invert transition duration-200 text-primary"
      />
    ),
    title: 'IDENTITY_MANAGEMENT_TITLE',
    description: 'IDENTITY_MANAGEMENT_DESCRIPTION',
    path: '/identity-management',
    isExternal: false,
    isPublic: false,
  },
  {
    id: '4',
    icon: (
      <Building2
        // size={64}
        className="w-full h-full group-hover:brightness-0 group-hover:invert transition duration-200 text-primary"
      />
    ),
    title: 'ORGANIZATION_MANAGEMENT_TITLE',
    description: 'ORGANIZATION_MANAGEMENT_DESCRIPTION',
    path: '/organization-management',
    isExternal: false,
    isPublic: false,
  },
  {
    id: '5',
    icon: (
      <FileStack
        // size={64}
        className="w-full h-full group-hover:brightness-0 group-hover:invert transition duration-200 text-primary"
      />
    ),
    title: 'DOCUMENT_MANAGEMENT_TITLE',
    description: 'DOCUMENT_MANAGEMENT_DESCRIPTION',
    path: '/document-management',
    isExternal: false,
    isPublic: true,
  },
];

export const getAvailableApps = (isAdmin: boolean, isOrgAdmin: boolean) => {
  return HOME_CONFIGS.filter((config) => isAdmin || isOrgAdmin || config.isPublic);
};

export const handleConfigItemClick = async (
  item: any,
  navigate: NavigateFunction,
  mutateAsync: any
) => {
  if (item.id === '2') {
    try {
      const data = await mutateAsync();
      if (data?.redirectUrl) window.open(data.redirectUrl, '_blank');
    } catch (err) {
      console.error(err);
    }
    return;
  }

  navigate(item.path);
};
